export enum TAB_IDS {
  TABLE_NOTES = 'table_notes',
  TABLE_DOCUMENT_REFERENCES = 'table_document_references',
  TABLE_SPREADSHEET_NOTES = 'table_spreadsheet_notes',
}

const DRAWER = {
  TABS: {
    NOTES: 'Notes',
    DOCUMENT_REFERENCES: 'Documents ',
    SPREADSHEET_NOTES: 'Sheets',
  },
  TAB_IDS,
};

export default DRAWER;
